

















import Vue from 'vue'
import Parent1 from './components/1-props/parent.vue'
import Parent2 from './components/2-emit/parent.vue'
import Parent3 from './components/3-2way/parent.vue'
import Parent31 from './components/31-v-model/parent.vue'
import Parent32 from './components/32-sync/parent.vue'
import ParentAnti from './components/34-anti/parent.vue'

export default Vue.extend({
  name: 'App',
  components: {
    Parent1,
    Parent2,
    Parent3,
    Parent31,
    Parent32,
    ParentAnti
  }
})
